import Link from 'next/link'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardActionArea from '@mui/material/CardActionArea'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import Chip from '@mui/material/Chip'
import { getAllGuides } from 'src/utils/guides'

const categoryColor = {
  Beginner: 'success',
  Strategy: 'primary',
  Reference: 'default',
  Advanced: 'warning'
}

export async function getStaticProps() {
  const guides = getAllGuides()

  return {
    props: { guides }
  }
}

const GuidesIndex = ({ guides }) => {
  return (
    <>

      <Grid container spacing={6}>
        <Grid size={{ xs: 12 }}>
          <Card
            sx={{
              padding: '2rem',
              borderRadius: '12px',
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
              borderTop: '6px solid',
              borderTopColor: 'primary.main'
            }}
          >
            <Typography variant='h4' component='h1' color='primary' gutterBottom>
              War and Order Guides
            </Typography>
            <Typography variant='body1' color='text.secondary'>
              Strategy articles, reference guides, and beginner walkthroughs — written by players, for players.
            </Typography>
          </Card>
        </Grid>

        {guides.length === 0 ? (
          <Grid size={{ xs: 12 }}>
            <Typography variant='body1' color='text.secondary' align='center'>
              Guides coming soon.
            </Typography>
          </Grid>
        ) : (
          guides.map(guide => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={guide.slug}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: '12px',
                  transition: 'transform 0.15s',
                  '&:hover': { transform: 'translateY(-2px)' }
                }}
              >
                <CardActionArea component={Link} href={`/guides/${guide.slug}/`} sx={{ flexGrow: 1 }}>
                  <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 0.5 }}>
                      <Chip
                        label={guide.category}
                        size='small'
                        color={categoryColor[guide.category] || 'default'}
                      />
                    </Box>
                    <Typography variant='h6' component='h2' color='primary'>
                      {guide.title}
                    </Typography>
                    <Typography variant='body2' color='text.secondary' sx={{ flexGrow: 1 }}>
                      {guide.description}
                    </Typography>
                    <Divider sx={{ my: 1 }} />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant='caption' color='text.secondary'>
                        {new Date(guide.publishedAt).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric'
                        })}
                      </Typography>
                      <Typography variant='caption' color='text.secondary'>
                        {guide.readingTime}
                      </Typography>
                    </Box>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </>
  )
}

GuidesIndex.noLoadingGate = true

export default GuidesIndex
